import { render, staticRenderFns } from "./c_input_textarea.vue?vue&type=template&id=d389945e&scoped=true"
import script from "./c_input_textarea.vue?vue&type=script&lang=js"
export * from "./c_input_textarea.vue?vue&type=script&lang=js"
import style0 from "./c_input_textarea.vue?vue&type=style&index=0&id=d389945e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d389945e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d389945e')) {
      api.createRecord('d389945e', component.options)
    } else {
      api.reload('d389945e', component.options)
    }
    module.hot.accept("./c_input_textarea.vue?vue&type=template&id=d389945e&scoped=true", function () {
      api.rerender('d389945e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/maintain/components/mobileConfigRight/c_input_textarea.vue"
export default component.exports